import ReceiptItem from './ReceiptItem.view';

export default ReceiptItem;
